<template>
  <div class="footer-container">
    <div class="footer-container-box">
      <div class="footer-container-box-contact">
        <div class="footer-container-box-contact-logo">
          <!-- <img
            src="https://image.bookgo.com.cn/bgOfficial/index/home-logo.png"
            alt=""
            style="width: 100%; height: 100%"
          /> -->
          <i class="iconfont iconbokulogo-copy"></i>
        </div>
        <ul class="footer-container-box-contact-info">
          <li>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/footer/footer-icon-address.png"
              alt=""
            />
            <p>博库信息技术（武汉）有限公司</p>
          </li>
          <li>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/footer/footer-icon-phone.png"
              alt=""
            />
            <p>027-87706707</p>
          </li>
          <li>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/footer/footer-icon-local.png"
              alt=""
            />
            <p>武汉市洪山区光谷创业街73号留创园A2158</p>
          </li>
          <li>
            <img
              src="https://image.bookgo.com.cn/bgOfficial/footer/footer-icon-mail.png"
              alt=""
            />
            <p>june.zhou@bookgoal.com.cn</p>
          </li>
        </ul>
      </div>
      <div class="footer-container-box-scene">
        <h2>场景方案</h2>
        <ul>
          <li @click="$router.push({ name: 'RFID' })">RFID图书馆解决方案</li>
          <li @click="$router.push({ name: 'headBranch' })">总分馆解决方案</li>
          <li @click="$router.push({ name: 'Ubiquitous' })">
            泛在图书馆解决方案
          </li>
          <li @click="$router.push({ name: 'tofeel' })">感知图书馆解决方案</li>
          <li @click="$router.push({ name: 'interact' })">
            互动图书馆解决方案
          </li>
          <li @click="$router.push({ name: 'webthings' })">
            物联图书馆解决方案
          </li>
          <li @click="$router.push({ name: 'antiepidemic' })">
            消毒防疫图书馆解决方案
          </li>
        </ul>
      </div>
      <div class="footer-container-box-business">
        <h2>行业方案</h2>
        <ul>
          <li @click="$router.push({ name: 'public' })">公共图书馆</li>
          <li @click="$router.push({ name: 'primaryschool' })">中小学图书馆</li>
          <li @click="$router.push({ name: 'highschool' })">高校图书馆</li>
          <li @click="$router.push({ name: 'enterprise' })">企事业图书馆</li>
          <li @click="$router.push({ name: 'city' })">城市书房</li>
          <li>数字文化馆</li>
          <li>智慧博物馆</li>
          <li>智慧旅游</li>
        </ul>
      </div>
      <div class="footer-container-box-linkus">
        <h2>联系我们</h2>
        <ul>
          <li @click="$router.push({ name: 'contact' })">联系合作</li>
          <li @click="$router.push({ name: 'aboutus' })">关于我们</li>
        </ul>
      </div>
      <!-- <div class="footer-container-box-QRCode">
        <h2>关注我们</h2>
        <img
          src="https://image.bookgo.com.cn/bgOfficial/index/footer-QRCode.png"
          alt=""
        />
      </div> -->
    </div>
    <div class="footer-container-copyright" @click="toCopyRight">
      <p>Copyright@2015-2020 BookGoal TechnologyCo. Ltd</p>
      <p>鄂ICP备16013452号-1</p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toCopyRight() {
      window.open("https://beian.miit.gov.cn/#/Integrated/index");
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/Footer.scss";
</style>
